var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-form',{attrs:{"value":_vm.value,"title":_vm.title,"allow-continue":false,"max-width":"800"},on:{"input":function($event){return _vm.$emit('input', $event)},"commit":_vm.save}},[_c('email-editor',{attrs:{"autofocus":_vm.autofocus},model:{value:(_vm.emailVal),callback:function ($$v) {_vm.emailVal=$$v},expression:"emailVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }